(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dd-product-presentation"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dd-product-presentation'))customElements.define('dd-product-presentation',class extends HTMLElement{connectedCallback(){document.body.style.setProperty('--dd-pdp-media',this.style.getPropertyValue('--dd-pdp-media'));document.body.style.setProperty('--dd-pdp-padding',this.style.getPropertyValue('--dd-pdp-padding'));this.observer=new ResizeObserver(()=>this.check());const panel=document.querySelector('.product-details');if(panel)this.observer.observe(panel);this.check()}check(){const panel=document.querySelector('.product-details');if(panel)panel.classList.toggle('dd-pdp-no-sticky',panel.scrollHeight>innerHeight-140)}disconnectedCallback(){this.observer?.disconnect();document.body.style.removeProperty('--dd-pdp-media');document.body.style.removeProperty('--dd-pdp-padding')}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
